module.exports = __webpack_public_path__ + "static/palliser-logo-0a043cdaa4f36d3b65a1efa256082a06.jpeg";